(() => {
  function init() {
    const nav = document.querySelector('[data-vx-i18-nav]');
    if (!nav) return;
    const intro = document.querySelector('[id$="__page_seo_intro_text_QKezWX"] .metafield-rich_text_field');
    const final = document.querySelector('[id$="__page_seo_final_text_ehBzcT"] .metafield-rich_text_field');
    if (!intro || !final) return;
    // Move the original nodes, never rewrite the curated metafield content.
    if (!intro.querySelector('.vx-i18-hero')) {
      const firstHeading = intro.querySelector('h2');
      if (firstHeading) {
        const hero = document.createElement('div');
        hero.className = 'vx-i18-hero';
        while (intro.firstChild && intro.firstChild !== firstHeading) hero.append(intro.firstChild);
        intro.prepend(hero);
        hero.after(nav);
      }
    }
    const normalize = text => text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    const headings = [...intro.querySelectorAll('h2'), ...final.querySelectorAll('h2')];
    const targets = {
      'iphone18-mudancas': intro.querySelector('h2'),
      'iphone18-especificacoes': headings.find(h => normalize(h.textContent).includes('especificacoes tecnicas')),
      'iphone18-preco': headings.find(h => normalize(h.textContent).includes('data de lancamento e preco')),
      'iphone18-produtos': document.querySelector('[id$="__tabbed_collections_kF37QT"] .section-heading-title'),
      'iphone18-perguntas': document.querySelector('[id$="__page_seo_faq_gCqeXJ"] .yv-csf-heading')
    };
    for (const [id, target] of Object.entries(targets)) {
      if (target) { target.id = id; target.classList.add('vx-i18-anchor'); }
      const link = nav.querySelector(`[href="#${id}"]`);
      if (link) link.hidden = !target;
    }
    if (!nav.dataset.initialized) {
      nav.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        history.replaceState(null, '', link.hash);
        target.setAttribute('tabindex', '-1');
        target.focus({preventScroll:true});
        target.scrollIntoView({behavior:'instant', block:'start'});
      });
      nav.dataset.initialized = 'true';
    }
    const target = Object.values(targets).find(node => node && `#${node.id}` === location.hash);
    if (target) requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
